export default __webpack_public_path__ + "static/media/other.1679deba.svg";